(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kp-cart-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.getElementById('KPCartExperience');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const toast = root.querySelector('#KPCartToast');
    const detail = root.querySelector('[data-kp-cart-toast-detail]');
    let hideTimer;
    const hideToast = () => {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    };
    const updateCounts = count => {
      document.querySelectorAll('[data-header-cart-count]').forEach(el => {
        el.textContent = count;
        if (el.classList.contains('kps-count')) el.classList.toggle('kps-count-empty', Number(count) === 0);
      });
    };
    const refreshAndShow = productForm => {
      const form = productForm.querySelector('form');
      const variantId = Number(form?.querySelector('[name="id"]')?.value || 0);
      const quantity = Math.max(1, Number(form?.querySelector('[name="quantity"]')?.value || 1));
      fetch(root.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}})
        .then(response => response.json())
        .then(cart => {
          updateCounts(cart.item_count);
          const item = cart.items.find(line => Number(line.variant_id) === variantId);
          let title = item?.product_title || item?.title || root.dataset.itemFallback;
          if (title.includes('|')) title = title.split('|').pop().trim();
          detail.textContent = quantity + '× ' + title;
          clearTimeout(hideTimer);
          toast.classList.add('is-visible');
          toast.removeAttribute('aria-hidden');
          hideTimer = setTimeout(hideToast, 4000);
        })
        .catch(() => {});
    };
    const bind = scope => {
      scope.querySelectorAll('product-form').forEach(productForm => {
        if (productForm.dataset.kpToastBound) return;
        productForm.dataset.kpToastBound = 'true';
        productForm.addEventListener('add-to-cart', () => refreshAndShow(productForm));
      });
    };
    bind(document);
    new MutationObserver(() => bind(document)).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load', () => bind(document));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kp-collection-menu-backup-before-remove-new-20260929"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('.kpcm').forEach(menu => {
    if (menu.dataset.initialized) return;
    menu.dataset.initialized = 'true';
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) {
        event.preventDefault();
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  });
  document.addEventListener('click', event => document.querySelectorAll('.kpcm[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  }));
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kp-collection-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('.kpcm').forEach(menu => {
    if (menu.dataset.initialized) return;
    menu.dataset.initialized = 'true';
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) {
        event.preventDefault();
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  });
  document.addEventListener('click', event => document.querySelectorAll('.kpcm[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  }));
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kp-flower-menu"] && !Shopify.designMode) return;
  try {
    (() => {
 const initialize = () => document.querySelectorAll('.kp-flower-menu').forEach(menu => {
  if(menu.dataset.ready) return;
  const button = menu.querySelector('.kp-flower-trigger');
  const panel = menu.querySelector('.kp-flower-panel');
  if(!button || !panel || !('showPopover' in panel)) return;
  menu.dataset.ready = 'true';
  let frame = 0;
  const place = () => {
   const rect = button.getBoundingClientRect();
   const width = Math.min(355,window.innerWidth - 24);
   const height = panel.offsetHeight || 234;
   const left = Math.max(12,Math.min(rect.left,window.innerWidth - width - 12));
   let top = rect.bottom + 7;
   if(top + height > window.innerHeight - 12 && rect.top > height + 19) top = rect.top - height - 7;
   panel.style.left = `${left}px`;
   panel.style.top = `${Math.max(12,top)}px`;
   panel.style.maxHeight = `${Math.max(100,window.innerHeight - Math.max(12,top) - 12)}px`;
  };
  const schedule = () => {
   if(!panel.matches(':popover-open')) return;
   cancelAnimationFrame(frame);
   frame = requestAnimationFrame(place);
  };
  panel.addEventListener('beforetoggle',event => {
   button.setAttribute('aria-expanded',String(event.newState === 'open'));
   if(event.newState === 'open') place();
  });
  panel.addEventListener('toggle',event => {
   if(event.newState === 'open') {
    place();
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('scroll',schedule,{passive:true,capture:true});
   } else {
    window.removeEventListener('resize',schedule);
    window.removeEventListener('scroll',schedule,true);
    cancelAnimationFrame(frame);
   }
  });
  panel.addEventListener('click',event => {if(event.target.closest('a')) panel.hidePopover();});
 });
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
 document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kp-menu-bak-0929"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('.kpcm').forEach(menu => {
    if (menu.dataset.initialized) return;
    menu.dataset.initialized = 'true';
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) {
        event.preventDefault();
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  });
  document.addEventListener('click', event => document.querySelectorAll('.kpcm[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  }));
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
